import React, { useState, useEffect } from 'react';
import 'Styles/site-global.css';

const DelayedProgressBar = ({ visible, setVisible }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(false);
    }, 8000);

    return () => clearTimeout(timer);
  }, []);

  return visible ? (
    <div className="moving-progress-bar-container">
      <div className="moving-progress-bar">
        <div className="progress" />
      </div>
    </div>
  ) : null;
};

export default DelayedProgressBar;
